import { connect } from 'react-redux';

import FieldPathsView from '../components/FieldPathsView';
import {
  getFieldPathKeys,
  getFieldPathsFor,
  getFieldPathsSearchEntry,
} from '../reducers/analyticsApp';
import changeSearchEntry from '../actions/fieldPaths';
import docsBookmarks from '../constants/docs';

const mapStateToProps = (state) => {
  const searchEntry = getFieldPathsSearchEntry(state);

  return {
    searchEntry,
    paths: getFieldPathsFor(state, searchEntry),
    searchEntries: getFieldPathKeys(state),
    scrolTo: docsBookmarks.fields,
  };
};

export default connect(mapStateToProps, { onSearchEntryChange: changeSearchEntry })(FieldPathsView);
